import { Club } from './../../clubs/club.model';
import { Component, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import { BaseFormComponent } from 'src/app/shared/components/base-form-component/base-form-component';
import { Product } from '../product.model';
import { ProductsService } from '../products.service';
import { ClubsService } from '../../clubs/clubs.service';
import { Category } from '../../settings/models/category.model';
import { CategoryService } from '../../settings/services/category.service';

@Component({
    selector: 'ng-products',
    templateUrl: 'products-form.component.html'
})

export class ProductFormComponent extends BaseFormComponent<Product> {

    public categories: Array<Category>;
    public category: Category;
    public clubs: Array<Club>;

    constructor(
        public injector:Injector,
        public categoryServ:CategoryService,
        public clubsServ:ClubsService,
        public productServ:ProductsService
    ) { 
        super(injector,'product','/admin/products',Product.fromJsonToObject,productServ);
    }

    protected initChildProprieties(): void {
        this.categories=new Array<Category>();
        this.clubs=new Array<Club>();
        this.category=new Category();
    }

    protected initChildMethods(): void {
        this.formSubscription.add(this.categoryServ.getAll().subscribe(categories=>{
            this.categories=categories;
            this.setCategory(this.objectForm.value.product_category_id);
        }));

        this.formSubscription.add(this.clubsServ.getAll().subscribe(clubs=>this.clubs=clubs));
        
    }

    public setCategory(idCategory:number){
        this.category=this.categories.find(category=>category.id==idCategory)
    }

    protected buildForm(): void {

        this.objectForm=this.formBuilder.group({

            description:this.formBuilder.control(null,[Validators.required]),

            title:this.formBuilder.control(null,[Validators.required]),

            product_category_id:this.formBuilder.control(null,[Validators.required]),

            subcategorias_id:this.formBuilder.control(null,[Validators.required]),

            flash:this.formBuilder.control(null,[Validators.required]),

            clubs_id:this.formBuilder.control(null,[Validators.required]),

            id:this.formBuilder.control(null),
        });
        
        //the input for send image files to api  
        // this.imageInputControlName='picture';
    }


}